import React from 'react';

import _ from 'lodash';
import classnames from 'classnames';

import { MODALS } from 'global-constants';
import Button from 'shared/components/Button';
import WithPush from 'shared/HOCs/WithPush';
import WithOpenModal from 'shared/HOCs/WithOpenModal';

import styles from './styles.module.scss';

class UnavailableContent extends React.Component {
  render() {
    const { label, button, description, className } = this.props;

    return (
      <div className={classnames(styles.contentWrapper, className)}>
        <div className={styles.lockContainer}>
          <div className={styles.lock}>
            <i className="material-icons">lock</i>
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.label}>{label}</div>
          <div className={styles.btn}>{button}</div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
    );
  }
}

class UnavailablePremiumContent extends React.Component {
  render() {
    let { label, buttonText, className } = this.props;
    const { openModal, userPlan, modalData } = this.props;

    if (_.isEmpty(label)) {
      label =
        'This content is only available with a Premium Account.\n' +
        (userPlan ? '' : 'Create a Premium account or sign in to view');
    }

    if (_.isEmpty(buttonText)) {
      buttonText = userPlan ? 'Upgrade plan' : 'Sign up for a Premium Account';
    }

    return (
      <div className={classnames(styles.unavailablePremiumContent, className)}>
        <UnavailableContent
          label={label}
          button={
            <Button
              color="orange-gradient"
              className={styles.signUpButton}
              onClick={() => {
                if (userPlan) {
                  openModal({
                    modalName: MODALS.CHANGE_PLAN
                  });
                } else {
                  openModal({ modalName: MODALS.SIGNUP, data: modalData });
                }
              }}>
              {buttonText}
            </Button>
          }
          description={
            !userPlan && (
              <React.Fragment>
                Already have an account?{' '}
                <span
                  onClick={() => openModal({ modalName: MODALS.LOGIN })}
                  className={styles.blue}>
                  Sign in
                </span>
              </React.Fragment>
            )
          }
        />
      </div>
    );
  }
}

UnavailablePremiumContent = WithOpenModal(WithPush(UnavailablePremiumContent));

export { UnavailableContent, UnavailablePremiumContent };
